<template>
  <div
    class="cart-overview-wrapper"
    role="dialog"
    aria-labelledby="cart-overview-title"
  >
    <transition name="slide-right">
      <div v-if="isActive" class="cart-overlay">
        <div ref="header" class="booking-header-extension">
          <div class="booking-header-close" data-component="booking-header-close">
            <span 
              class="icon-close" 
              :aria-label="tc('booking.close')" 
              tabindex="0" 
              aria-hidden="true" 
              @click="closeModal" 
              @keypress.enter.prevent="closeModal"
              @keypress.space.prevent="closeModal"></span>
          </div>
          <div class="booking-header-extension-wrapper container">
            <div class="booking-header-extension-left">
              <div id="cart-overview-title" class="title">{{tc('booking.stayDetails')}}</div>
            </div>
          </div> 
        </div>
        <div class="overview-scroll" :style="[{ height: scrollHeight + 'px' }]">
          <cart-overview
            :cart="cart"
            without-totals
            can-edit
            @edit="$emit('edit', $event)"
            @close="closeModal"
          />
        </div>
        <div ref="footer" class="booking-footer">
          <cart-totals class="booking-footer-wrapper final-total" />
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="isActive" class="backlight" @click="closeModal" />
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import TabTrapMixin from '@mixins/tab-trap'
import CartOverview from '../../pages/check-out/components/cart-overview.vue'
import CartTotals from '../../pages/check-out/components/cart-totals.vue'

export default {
  name: 'cart-overlay',
  components: {
    CartOverview,
    CartTotals
  },
  mixins: [TabTrapMixin],
  props: {
    isActive: Boolean
  },
  data: () => ({
    scrollHeight: 'auto'
  }),
  computed: {
    ...mapState('cart', ['cart']),
    ...mapGetters('i18n', ['tc']),
    ...mapState('responsive', ['height', 'width'])
  },
  watch: {
    isActive(val) {
      if (val) {
        if (!window.adobeDataLayer) { 
            this.$track({
              events: {
                siteInteraction: true
              },
              interaction: {
                name: 'cart opened',
                type: 'cart'
              }
            })
        }
        this.$nextTick(() => {
          this.calculateScroll()
          this.getFocusableElements()
          this.firstFocusableEl.focus()
        })
      }
    },
    width(val) {
      this.$nextTick(() => {
        this.calculateScroll()
      })
    }
  },
  methods: {
    calculateScroll() {
      const headerHeight = this.$refs.header && this.$refs.header.getBoundingClientRect().height
      const footerHeight = this.$refs.footer && this.$refs.footer.getBoundingClientRect().height
      const height = this.height - (headerHeight ?? 0) - (footerHeight ?? 0)
      if (this.scrollHeight !== height) {
        this.scrollHeight = height
      }
    },
    closeModal() {
      this.$emit('hide-cart')
    }
  },
}
</script>